import "./containers/third/polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import store from './store';
//import routes from './routes';

import App from './containers/App';

import './styles/main.css';


/*const showLogs = true; 
const showWarns = true; 
const showErrors = true; 

// define a new console
var console=(function(oldCons){
    return {
        log: function(...restArgs){
        	if(showLogs) {
                oldCons.log.apply(oldCons, restArgs);            
            }
        },
        info: function (...restArgs) {
        	if(showLogs) {
                oldCons.info.apply(oldCons, restArgs);            
            }
        },
        warn: function (...restArgs) {
            if(showWarns) {
                oldCons.warn.apply(oldCons, restArgs);            
            }
        },
        error: function (...restArgs) {
            if(showErrors) {
                oldCons.error.apply(oldCons, restArgs);            
            }
        }
    };
}(window.console));

//Then redefine the old console
window.console = console;*/

ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js